module.exports = __webpack_public_path__ + "static/img/frack31.9e037905.png";